<template>
  <div class="add-dialog">
    <el-dialog title="学生行为新增" :visible.sync="behaviorAddDialogShow" width="1000px" :before-close="dialogClose"
      @open="dialogOpen">
      <!-- 学年学期 -->
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="ruleForm" label-position="top"
        :inline="true">
        <el-form-item label="选择学年:" label-width="100px" prop="schoolYear">
          <!-- <el-date-picker style="width: 235px" v-model="ruleForm.schoolYear" type="year" value-format="yyyy" placeholder="请选择学年"
            @change="schoolYearChangeHandle">
          </el-date-picker> -->
          <year-range-picker style="width: 250px;" v-model="ruleForm.schoolYear" />
        </el-form-item>
        <el-form-item label="选择学期:" label-width="100px" prop="semester">
          <el-select v-model="ruleForm.semester" placeholder="请选择学期" style="width: 235px">
            <el-option v-for="item in semesterOptions" :key="item.dictValue" :label="item.dictLabel"
              :value="item.dictValue">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="记录时间:" label-width="100px" prop="recordTime">
          <el-date-picker style="width: 235px" v-model="ruleForm.recordTime" type="date" value-format="yyyy-MM-dd" placeholder="请选择时间">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <!-- 行为内容 -->
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="ruleForm"
        label-position="top">
        <el-form-item label="奖惩情况" prop="behaviorContent">
          <el-input type="textarea" :autosize="{ minRows: 6, maxRows: 8 }" v-model="ruleForm.behaviorContent"
            :maxlength="maxlength" show-word-limit></el-input>
        </el-form-item>
      </el-form>
      <div class="btn-list">
        <el-button type="primary" @click="submit">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: [
    'behaviorAddDialogShow',
    'semesterOptions',
    'studentId',
    'studentName'
  ],
  data() {
    return {
      maxlength: 1000,
      ruleForm: {
        schoolYear: "",
        semester: "",
        recordTime: "",
        behaviorContent: "",
      },
      rules: {
        behaviorContent: [{ required: true, message: "请输入行为内容", trigger: "blur" }],
        schoolYear: [{ required: true, message: "请选择学年", trigger: "change" }],
        semester: [{ required: true, message: "请选择学期", trigger: "change" }],
        recordTime: [{ required: true, message: "请选择时间", trigger: "change" }],
      },
    };
  },
  methods: {
    // 开启弹窗
    dialogOpen() {
      this.ruleForm = {
        schoolYear: "",
        semester: "",
        recordTime: "",
        behaviorContent: "",
      };
    },
    // 关闭弹出窗口
    dialogClose() {
      this.$emit("update:behaviorAddDialogShow", false);
      this.$refs["ruleForm"].clearValidate(); //移除表单检验结果
    },
    submit() {
      let user = this.user;
      let data = {
        "schoolId": user.schoolId,
        "schoolName": user.schoolName,
        "teacherId": user.id,
        "teacherName": user.teacherName,
        "studentId": this.studentId,
        "studentName": this.studentName,
        "recordTime": this.ruleForm.recordTime,
        "recordContent": this.ruleForm.behaviorContent,
        "schoolYear": this.ruleForm.schoolYear,
        "semester": this.ruleForm.semester
      };
      this.post(this.$url.insertStudentBehavior, data).then(res => {
        if (res.code == 200) {
          // 上传成功，刷新列表，关闭dialog
          this.$emit("refresh");
          this.dialogClose();
          this.$message.success(res.msg);
          return;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    schoolYearChangeHandle(e) {

    },
  },
};
</script>

<style lang="scss" scoped>
@import "./behaviorAddDialog.scss";
</style>